import { getMe } from '~/api/user';

export const state = () => ({
  user: {},
  me: {},
});

export const getters = {
  getUser: state => state.user,
  getMe: state => state.me || {},
};

export const mutations = {
  setUser(state, data) {
    state.user = data;
  },
  setMe(state, data) {
    state.me = data;
  },
};

export const actions = {
  async getMe({ commit, state, rootState }) {
    if (state.me.id) return;
    if (!rootState?.auth?.token?.login) return;
    try {
      const response = await getMe(this.$axios);
      if (response.meta.http_status === 200) commit('setMe', response.data);
      return response;
    } catch (error) {
      console.error('getMe', error, error.message);
      // handle error
    }
  },
  setMe({ commit }, data) {
    commit('setMe', data);
  },
};
